export default __webpack_public_path__ + "static/media/btc.5562b2e9.svg";